import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnChanges, OnDestroy, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { KeyValue } from '@commonInterfaces/iKeyValue';
import { BasicControlValueAccessor } from '@commonSuper/basic-control-value-accessor';
import { NgbDropdown, NgbDropdownAnchor, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'lib-dropdown-box',
    templateUrl: './dropdown-box.component.html',
    styleUrls: ['./dropdown-box.component.scss'],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DropdownBoxComponent), multi: true }],
    imports: [NgbDropdown, NgbDropdownAnchor, NgClass, NgbDropdownMenu]
})
export class DropdownBoxComponent extends BasicControlValueAccessor implements ControlValueAccessor, OnInit, OnChanges, OnDestroy {


	constructor(protected override elRef: ElementRef, private cdRef: ChangeDetectorRef) {
		super(elRef)
	}
	ngOnInit(): void {
		this.init();

	}

	protected focusOnOpen() {
		this.elRef.nativeElement.focus();
	}

	public detectChanges() {
		this.cdRef.markForCheck();
	}


	public override valueChange(item: KeyValue) {
		if (!this.isOptionDisabled(item.value)) {
			this.model = item.value;
			this.title = item.key;
			this.markForChange();
		}
	}

	public isOptionDisabled(value: number) {
		return this.disabledOptions?.some(item => item === value)
	}

}
